import RestAPI from 'components/Common/restApi';

export const index = (serviceRequestUuid) =>
  RestAPI.getWithFormData('/alpha/consumer_lending/financing_details', { service_request_uuid: serviceRequestUuid });
